export const formatTo12Hour = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(':');
  let h = parseInt(hours, 10);
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12; // Convert '0' to '12'
  return `${h}:${minutes} ${ampm}`;
};